import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    pestId: null,
    cropId: null,
    pestName: null,
    cropName: null,
};

const entitySelector = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        storeEntitiesId(state, action) {
            state.pestId = action.payload.pestId;
            state.cropId = action.payload.cropId;
            state.cropName = action.payload.cropName;
            state.pestName = action.payload.pestName;
        },

    }
});

export const {storeEntitiesId } = entitySelector.actions;

export default entitySelector.reducer;